import React from "react";
import GlobalChartDialog from "components/basic/chart-in-dialog-button/GlobalChartDialog";
import EasasGlobalAlerts from "./EasasGlobalAlerts";
import EasasGlobalChartDialog from "./EasasGlobalChartDialog";
import EasasGlobalConfirmDialog from "./EasasGlobalConfirmDialog";
import EasasGlobalTooltip from "./EasasGlobalTooltip";

export default function EasasGlobalFragment() {
  return (
    <>
      <GlobalChartDialog />
      <EasasGlobalTooltip />
      <EasasGlobalAlerts />
      <EasasGlobalChartDialog />
      <EasasGlobalConfirmDialog />
    </>
  );
}
